import { Component, input, output, ViewChild } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ModalComponent, SvgComponent } from "@ramudden/ui";

@Component({
    selector: "app-coordinator-choice-dialog",
    standalone: true,
    imports: [ModalComponent, TranslateModule, SvgComponent],
    templateUrl: "./coordinator-choice-dialog.component.html",
    styleUrl: "./coordinator-choice-dialog.component.scss",
})
export class CoordinatorChoiceDialogComponent {
    @ViewChild(ModalComponent, { static: true }) dialog: ModalComponent;

    workerName = input<string>("");

    joinTeamClicked = output<void>();
    viewTeamsClicked = output<void>();

    openModal() {
        this.dialog.openModal();
    }

    onJoinTeam() {
        this.dialog.closeModal();
        this.joinTeamClicked.emit();
    }

    onViewTeams() {
        this.dialog.closeModal();
        this.viewTeamsClicked.emit();
    }
}
